<template>
  <v-container>
    <h2 class="text-lg-center text-md-center text-sm-center earth-color">Terms and Conditions</h2>
    <v-card>
     <v-container>
       <v-container>
         <span v-html="singlePage.description"></span>
       </v-container>
     </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'front-terms-and-conditions',
  data () {
    return {}
  },
  created () {
    this.$store.dispatch('get_page', 't&c')
  }
}
</script>

<style scoped>

</style>
